function getPropertyByPath(source, path) {
    const keys = path.split('.');
    let current = source;
    for (const p of keys) {
        if (current[p] === undefined) {
            return undefined;
        }
        current = current[p];
    }
    return current;
}
export default getPropertyByPath;